import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Mail, Newspaper, ShieldCheck, Megaphone } from 'lucide-react';

const ContactPage = () => {
  const contactCards = [
    {
      title: 'News tips & story leads',
      description: 'Send what happened, where it happened, and any links, screenshots, or public social posts that help verify the tip.',
      icon: Newspaper,
      href: 'mailto:contact@coyp.me?subject=News%20Tip%20for%20COYP',
      cta: 'Send a tip',
      testId: 'contact-tips-card',
    },
    {
      title: 'Corrections & updates',
      description: 'If something needs a correction or more context, email the story link plus the specific detail that should be reviewed.',
      icon: ShieldCheck,
      href: 'mailto:contact@coyp.me?subject=Correction%20Request%20for%20COYP',
      cta: 'Request a correction',
      testId: 'contact-corrections-card',
    },
    {
      title: 'Advertising & business',
      description: 'For partnerships, sponsorships, and business inquiries, send your company name, goal, and deadline.',
      icon: Megaphone,
      href: 'mailto:contact@coyp.me?subject=Business%20Inquiry%20for%20COYP',
      cta: 'Business inquiry',
      testId: 'contact-business-card',
    },
  ];

  return (
    <div className="min-h-screen bg-black" data-testid="contact-page">
      <SEO title="Contact" description="Contact Check On Yo Peoples TV for tips, corrections, advertising, and general questions." type="website" />
      <Header />
      <div className="max-w-5xl mx-auto px-4 py-12 text-gray-300">
        <div className="max-w-3xl space-y-4 mb-8">
          <h1 className="text-4xl sm:text-5xl font-black text-white">Contact COYP</h1>
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
            Got a tip, correction, business request, or general question? Reach out and include as much detail as you can so we can review it quickly.
          </p>
          <a
            href="mailto:contact@coyp.me"
            className="inline-flex items-center gap-2 mt-2 bg-yellow-600 hover:bg-yellow-500 text-white font-bold px-5 py-3 transition-colors"
            data-testid="contact-email-link"
          >
            <Mail size={16} /> contact@coyp.me
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {contactCards.map(({ title, description, icon: Icon, href, cta, testId }) => (
            <article key={title} className="border border-[#222] bg-[#0d0d0d] p-5 flex flex-col" data-testid={testId}>
              <Icon size={20} className="text-yellow-400 mb-4" />
              <h2 className="text-white font-bold text-lg mb-2">{title}</h2>
              <p className="text-sm text-gray-400 leading-relaxed flex-1">{description}</p>
              <a href={href} className="mt-5 inline-flex text-sm font-bold text-yellow-400 hover:text-yellow-300" data-testid={`${testId}-cta`}>
                {cta}
              </a>
            </article>
          ))}
        </div>

        <div className="mt-8 border border-yellow-500/20 bg-yellow-500/10 p-5" data-testid="contact-response-panel">
          <h2 className="text-white font-bold text-lg mb-2">What to include</h2>
          <ul className="list-disc pl-5 space-y-2 text-sm text-gray-300">
            <li>The story link or topic you are referring to</li>
            <li>Any public source links, screenshots, or timestamps that support your note</li>
            <li>Your best contact information if you want a follow-up</li>
          </ul>
          <p className="text-gray-400 text-xs mt-4">We do our best to respond to tips and inquiries within 1–2 business days.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
